module.exports = __webpack_public_path__ + "img/footer_phone.d8944cbf.svg";